






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import { Utils } from "@/core/Utils";
import NominaTransaccion from '@/models/tarjeta/nomina-transaccion.model';

@Component
export default class PerfilCiudadanoListaCuentas extends BaseVue {
  @Prop() readonly cedula!: string;
  //@Prop() readonly codigoHogar!: string;

  created() {
    let props = [];
    props.push(new TipoTramiteComponentProp("cedula", "string"));
    //props.push(new TipoTramiteComponentProp("codigoHogar", "string"));
    this.$emit("render", props);
  }

  onUpdateNtTable(config: BTableConfig<NominaTransaccion>) {
    config.checkable = true;
  }
}
